import { render, staticRenderFns } from "./RecipientsNoticeList.vue?vue&type=template&id=a30b7494&scoped=true&"
import script from "./RecipientsNoticeList.vue?vue&type=script&lang=js&"
export * from "./RecipientsNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30b7494",
  null
  
)

export default component.exports